import React from 'react';
import type { RouteSuggestion } from '../types';

export interface MapRouteOptionsChipsProps {
  routeSuggestions: RouteSuggestion[];
  fastestRoute: RouteSuggestion | null;
  activeRouteSuggestion: number;
  onSelectFastest: () => void;
  onSelectSuggested: (index: number) => void;
}

/** Fastest + Route 1… chips (shared: route details header and collapsed map strip). */
export const MapRouteOptionsChips: React.FC<MapRouteOptionsChipsProps> = ({
  routeSuggestions,
  fastestRoute,
  activeRouteSuggestion,
  onSelectFastest,
  onSelectSuggested,
}) => {
  if (routeSuggestions.length < 1) return null;

  return (
    <>
      <p className="text-sm text-gray-500 mb-2">
        {routeSuggestions.length > 1 ? 'Route options:' : 'Your route:'}
      </p>
      <div className="flex gap-2 overflow-x-auto">
        {fastestRoute && (
          <button
            type="button"
            onClick={onSelectFastest}
            className={`flex-shrink-0 px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
              activeRouteSuggestion === -1
                ? 'bg-black text-white'
                : 'bg-gray-900 text-white hover:bg-gray-800'
            }`}
          >
            Fastest
            <span className="block text-xs opacity-75">
              0 stops • {Math.round(fastestRoute.total_time)} min
            </span>
          </button>
        )}
        {routeSuggestions.map((suggestion, index) => {
          const stops = suggestion.stops || suggestion.suggested_stops;
          const numStops = suggestion.num_stops || stops?.length || 0;
          return (
            <button
              type="button"
              key={index}
              onClick={() => onSelectSuggested(index)}
              className={`flex-shrink-0 px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                activeRouteSuggestion === index
                  ? 'bg-blue-600 text-white'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              Route {index + 1}
              <span className="block text-xs opacity-75">
                {numStops} stops • {Math.round(suggestion.total_time)} min
              </span>
            </button>
          );
        })}
      </div>
    </>
  );
};
